import { Format } from '@swegaming-ab/nuxtjs-helpers';

export default class Base {
    constructor(object, store) {

        this._store = store;
        if(object.hasOwnProperty('data') && object.hasOwnProperty('lang')) {
            // prismic
            object = object.data;
        }

        if(object.hasOwnProperty('core_api')) {
            object = object.core_api;
            this._data = object.brand_data;
            this._core = object.core_data;
            this._ratings = object.ratings;
        }
        else {
            this._data = object;
            this._core = undefined;
            this._ratings = undefined;
        }
    }
}